import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import Button from '../../../../../../utils/components/Button/Button'
import useModal from '../../../../../../utils/hooks/useModal'
import { deleteSubcategoryProduct } from '../../../../../actions/subCategoriesActions'
import styles from './CategoryDetail.module.css'
const CategoryDetaill = ({ subCategories, formik, isEdit, setIsEdit }) => {
  const [ref, isShowModal, setIsShowModal] = useModal(false)
  const [subCategory, setSubCategory] = useState(null)

  return (
    <div>
      <div className={styles.input_container}>
        <input type="text" name="name" value={formik.values.name}
          onChange={formik.handleChange} />
        <Button text={`${isEdit ? 'editar' : 'crear'}`} onClick={formik.handleSubmit} />
      </div>
      <div className={styles.grid_presentations}>
        {

          subCategories.map(subCategory => (
            <div key={subCategory._id} className={styles.presentation_card}>
              {subCategory.name}
              <div className={styles.presentation_card_btn}>
                <Button styles={{ width: "50%" }} text='Editar' onClick={() => {
                  setIsEdit(true)
                  formik.setFieldValue('name', subCategory.name)
                  formik.setFieldValue('id', subCategory._id)
                  //setPresentation(presentation.name)
                  //  setPresentationId(presentation._id)
                }} />
                <Button styles={{ width: "50%" }} text='Eliminar' onClick={()=>{
                  setSubCategory(subCategory)
                  setIsShowModal(true)
                }}/>
              </div>
            </div>
          ))
        }
      </div>

      <Modal subCategory={subCategory} displayModal={isShowModal} close={() => setIsShowModal(false)} />
    </div>
  )
}
const Modal = ({ subCategory, displayModal, close }) => {
  const dispatch = useDispatch()
  const divStyle = {
      display: displayModal ? 'block' : 'none'
  }
  if (!subCategory) {
      return <></>
  }
  return (
      <div className={"modal"} style={divStyle}>
          <div className="modal-content">
              <div>¿Está seguro que quiere borrar la sub-categoría ?: {subCategory.name}</div>
              <Button styles={{ width: "50%" }} 
              onClick={() => {dispatch(deleteSubcategoryProduct(subCategory._id,close))}} 
              text='Eliminar' />
              <Button styles={{ width: "50%" }} 
              onClick={() => {close()}}
              text='Cancelar' />
          </div>

      </div>
  )
}
export default CategoryDetaill